var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "coin_Large",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4458",
    "data-name": "Group 4458"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11092",
    "data-name": "Rectangle 11092",
    width: 65,
    height: 65,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4459",
    "data-name": "Group 4459",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46177",
    "data-name": "Path 46177",
    d: "M32.5,2A30.5,30.5,0,1,0,63,32.5,30.511,30.511,0,0,0,32.5,2Zm2.684,48.068v1.1A2.688,2.688,0,0,1,32.5,53.85h0a2.688,2.688,0,0,1-2.684-2.684V49.885a12.229,12.229,0,0,1-8.2-6.4,2.629,2.629,0,0,1,1.372-3.6l.213-.091a2.594,2.594,0,0,1,3.294,1.19,7.137,7.137,0,0,0,6.466,4.179c2.837,0,6.039-1.464,6.039-4.91,0-2.928-2.135-4.453-6.954-6.191-3.355-1.19-10.218-3.142-10.218-10.1,0-.305.031-7.32,7.991-9.028v-1.1A2.688,2.688,0,0,1,32.5,11.15h0a2.688,2.688,0,0,1,2.684,2.684v1.128a10.336,10.336,0,0,1,6.588,3.965,2.592,2.592,0,0,1-1.1,3.965h0a2.665,2.665,0,0,1-3.111-.854,5.8,5.8,0,0,0-4.88-2.348c-2.135,0-5.521,1.128-5.521,4.24,0,2.9,2.623,4,8.052,5.795,7.32,2.531,9.181,6.253,9.181,10.523C44.4,48.269,36.77,49.794,35.184,50.068Z",
    transform: "translate(-2 -2)",
    fill: "#374955"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinLarge);
export default __webpack_public_path__ + "static/media/coin_Large.52a9414b1022a48efa75b7fbe1b72f7e.svg";
export { ForwardRef as ReactComponent };